import { graphql } from "../generated";

export const DeliverableDocument = graphql(`
  query Deliverable(
    $deliverableKey: ID!
    $includeAudio: Boolean = false
    $includeCanUpdateRevisions: Boolean = false
    $includePdfPreviews: Boolean = false
    $includeQualityAssuranceReport: Boolean = false
    $includeViewerOperationChecks: Boolean = false
    $includeCreativeX: Boolean = false
    $intent: RevisionIntent = CORRECTIVE
  ) {
    deliverable(key: $deliverableKey) {
      key
      creativeX @include(if: $includeCreativeX) {
        state
        preflight {
          id
          isLite
          status
        }
        result {
          id
          qualityTier
          score
          scorecardUrl
          guidelines {
            name
            passed
            weight
          }
        }
      }
      audio @include(if: $includeAudio) {
        url
        type
      }
      canUpdateRevisions(intent: $intent)
        @include(if: $includeCanUpdateRevisions)
      viewerOperationChecks(operations: [CREATE_REVISION])
        @include(if: $includeViewerOperationChecks) {
        operation
        authorization {
          passes
        }
        validation {
          passes
        }
      }
      exportFilename
      specificationKey
      duration
      file {
        key
        url
        size
        contentType
        totalUnits
        unit
        preview(
          options: {
            quality: UNSCALED
            accept: [VIDEO_MP4, IMAGE_PNG, IMAGE_JPEG, IMAGE_GIF]
          }
        ) {
          url
          width
          height
        }
        previews(
          params: {
            options: {
              quality: UNSCALED
              accept: [IMAGE_PNG]
              unit: PAGE
              slices: { unitsPerSlice: 1 }
            }
          }
        ) @include(if: $includePdfPreviews) {
          nodes {
            url
            width
            height
            currentIndex
          }
        }
      }
      qualityAssuranceReport @include(if: $includeQualityAssuranceReport) {
        id
        status
        results {
          id
          resultState
          reportTopics {
            topic
            categories {
              category
              score
              items {
                key
                feedback
                timestamp
                score
              }
            }
          }
        }
      }
    }
  }
`);
